import microuniversoApi from "app/api/microuniversoApi";
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";
import store from "app/redux/store/store";
import { DescontoAplicados, DescontoOrcamento } from "app/types/Desconto";
import { WindowMU } from "app/types/WindowMU";

declare var window: WindowMU

function atualizarEstados(desconto: DescontoAplicados) {

    const orcamentoAlterado = {
        ...store.getState().orcamento,
        CodigoMotivoDesconto: desconto.CodigoMotivoDesconto,
        DescontoAcumulado: desconto.DescontoAcumulado,
        ItensOrcamento: desconto.ItensOrcamento,
        ParcelasFormaPagamento: desconto.ParcelasFormaPagamento,
        PercentualDesconto: desconto.PercentualDesconto,
        PercentualDescontoAcumulado: desconto.PercentualDescontoAcumulado,
        PercentualDescontoAcumuladoSobreMercadoriasImportadas: desconto.PercentualDescontoAcumuladoSobreMercadoriasImportadas,
        PercentualDescontoAcumuladoSobreMercadoriasNacionais: desconto.PercentualDescontoAcumuladoSobreMercadoriasNacionais,
        PercentualDescontoSobreMercadoriasImportadas: desconto.PercentualDescontoSobreMercadoriasImportadas,
        PercentualDescontoSobreMercadoriasNacionais: desconto.PercentualDescontoSobreMercadoriasNacionais,
        PercentualSeguroEntrega: desconto.PercentualSeguroEntrega,
        PerdaCotacao: desconto.PerdaCotacao,
        SubTotal: desconto.SubTotal,
        TipoTratamentoDesconto: desconto.TipoTratamentoDesconto,
        UltimaAtualizacao: desconto.UltimaAtualizacao,
        ValorAcrescimoFinanceiro: desconto.ValorAcrescimoFinanceiro,
        ValorDesconto: desconto.ValorDesconto,
        ValorDescontoAcumuladoSobreMercadoriasImportadas: desconto.ValorDescontoAcumuladoSobreMercadoriasImportadas,
        ValorDescontoAcumuladoSobreMercadoriasNacionais: desconto.ValorDescontoAcumuladoSobreMercadoriasNacionais,
        ValorDescontoIcms: desconto.ValorDescontoIcms,
        ValorDescontoSobreMercadoriasImportadas: desconto.ValorDescontoSobreMercadoriasImportadas,
        ValorDescontoSobreMercadoriasNacionais: desconto.ValorDescontoSobreMercadoriasNacionais,
        ValorDespesasInclusas: desconto.ValorDespesasInclusas,
        ValorFrete: desconto.ValorFrete,
        ValorIPI: desconto.ValorIPI,
        ValorSeguroEntrega: desconto.ValorSeguroEntrega,
        ValorSubstituicao: desconto.ValorSubstituicao,
        ValorTotal: desconto.ValorTotal,
        ValorTotalIPISobreMercadoriasImportadas: desconto.ValorTotalIPISobreMercadoriasImportadas,
        ValorTotalIPISobreMercadoriasNacionais: desconto.ValorTotalIPISobreMercadoriasNacionais,
        ValorTotalMercadorias: desconto.ValorTotalMercadorias,
        ValorTotalMercadoriasImportadas: desconto.ValorTotalMercadoriasImportadas,
        ValorTotalMercadoriasNacionais: desconto.ValorTotalMercadoriasNacionais,
        ValorTotalPendente: desconto.ValorTotalPendente,
        ValorTotalSTSobreMercadoriasImportadas: desconto.ValorTotalSTSobreMercadoriasImportadas,
        ValorTotalSTSobreMercadoriasNacionais: desconto.ValorTotalSTSobreMercadoriasNacionais,
        ValorTotalSolicitado: desconto.ValorTotalSolicitado,
        ValorServicoAdicionalDespesa: desconto.ValorServicoAdicionalDespesa,

        SaldoCashbackCliente: desconto.SaldoCashbackCliente, // 438892
        ValidadeCashbackCliente: desconto.ValidadeCashbackCliente,
        ValorCashbackUtilizado: desconto.ValorCashbackUtilizado,
        AplicaDescontoCashback: desconto.AplicaDescontoCashback,
    }

    const atualizarOrcamentoLegado = () => {
        const orcamentoLegado = window.orcamentoController.model

        orcamentoLegado.atualizar(orcamentoAlterado, true, true)

        store.dispatch(sobrescreverInformacoesAction(orcamentoAlterado))
    }

    atualizarOrcamentoLegado()

}

export async function aplicarDescontosAdicionais({ descontos }: { descontos: DescontoOrcamento }) {
    const resultado = await microuniversoApi.Orcamento.aplicarDescontosAdicionais(
        store.getState().orcamento.IdentificadorOrcamento, descontos
    )

    resultado && !resultado.HasErrors && atualizarEstados(resultado)
}